import React from 'react';
import styled from 'styled-components';

import {
  PLACEMENT_ENUM, THEME_ENUM, Tooltip, TRIGGER_ENUM,
} from '../Tooltip';
import iconImage from '../../assets/images/icons/info-icon-dark.svg';

const StyledIcon = styled.div`
  background-image: url("${iconImage}");
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 6px;
`;

const StyledTooltipWrapper = styled.div`
  max-width: 280px;
`;

export const InfoTooltip = React.memo(props => (
  <Tooltip
    overlay={<StyledTooltipWrapper {...props} />}
    theme={THEME_ENUM.LIGHT}
    trigger={TRIGGER_ENUM.HOVER}
    placement={PLACEMENT_ENUM.TOP}
  >
    <StyledIcon />
  </Tooltip>
));
